/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { StageCreationRequest } from '../model';
// @ts-ignore
import { StageDetail } from '../model';
// @ts-ignore
import { StageTransitionCreationRequest } from '../model';
// @ts-ignore
import { StageTransitionDetail } from '../model';
/**
 * StagesAdminApi - axios parameter creator
 * @export
 */
export const StagesAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new stage
         * @summary Creates a new stage
         * @param {StageCreationRequest} stageCreationRequest Stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStage: async (stageCreationRequest: StageCreationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stageCreationRequest' is not null or undefined
            assertParamExists('createStage', 'stageCreationRequest', stageCreationRequest)
            const localVarPath = `/admin/stages/stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stageCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new transition
         * @summary Creates a new transition
         * @param {StageTransitionCreationRequest} stageTransitionCreationRequest Transition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransition: async (stageTransitionCreationRequest: StageTransitionCreationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'stageTransitionCreationRequest' is not null or undefined
            assertParamExists('createTransition', 'stageTransitionCreationRequest', stageTransitionCreationRequest)
            const localVarPath = `/admin/stages/stages/transitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stageTransitionCreationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an existing stage.
         * @summary Deletes an existing stage
         * @param {number} id stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStage: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStage', 'id', id)
            const localVarPath = `/admin/stages/stages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an existing transition.
         * @summary Deletes an existing transition
         * @param {number} id transition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransition: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTransition', 'id', id)
            const localVarPath = `/admin/stages/stages/transitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retrieves all initial stage transitions for a given entity type. Returns array of StageTransitionDetail objects.
         * @summary retrieves all initial stage transitions for an entity type.
         * @param {number} entityType Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialStageTransitions: async (entityType: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getInitialStageTransitions', 'entityType', entityType)
            const localVarPath = `/admin/stages/stages/transitions/initial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves a single stage given an ID
         * @param {number} id Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStage: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStage', 'id', id)
            const localVarPath = `/admin/stages/stages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retrieves all the stages. Can supply a entityType query param to get stages for a specific entity Type.
         * @summary retrieves all the stages.
         * @param {number} [entityType] Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStages: async (entityType?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/stages/stages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieves a single transition given an ID
         * @param {number} id Transition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransition: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTransition', 'id', id)
            const localVarPath = `/admin/stages/stages/transitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * retrieves all the transitions. Can supply a entityType query param to get transitions for a specific entity Type, or stage query param to get transitions for a specific stage.
         * @summary retrieves all the transitions.
         * @param {number} [entityType] Entity Type ID
         * @param {number} [stage] Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransitions: async (entityType?: number, stage?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/stages/stages/transitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entityType'] = entityType;
            }

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sets the order for stages
         * @param {{ [key: string]: number; }} requestBody a Map of Stage ID keys and their corresponding sort index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStages: async (requestBody: { [key: string]: number; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('orderStages', 'requestBody', requestBody)
            const localVarPath = `/admin/stages/stages/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary sets the order for transitions
         * @param {{ [key: string]: number; }} requestBody a Map of transition ID keys and their corresponding sort index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderTransitions: async (requestBody: { [key: string]: number; }, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('orderTransitions', 'requestBody', requestBody)
            const localVarPath = `/admin/stages/stages/transitions/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing stage. id must match in the object and uri.
         * @summary Updates an existing stage
         * @param {number} id Stage ID
         * @param {StageDetail} stageDetail Stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStage: async (id: number, stageDetail: StageDetail, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStage', 'id', id)
            // verify required parameter 'stageDetail' is not null or undefined
            assertParamExists('updateStage', 'stageDetail', stageDetail)
            const localVarPath = `/admin/stages/stages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stageDetail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing transition. id must match in the object and uri.
         * @summary Updates an existing transition
         * @param {number} id Transition ID
         * @param {StageTransitionDetail} stageTransitionDetail Transition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransition: async (id: number, stageTransitionDetail: StageTransitionDetail, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTransition', 'id', id)
            // verify required parameter 'stageTransitionDetail' is not null or undefined
            assertParamExists('updateTransition', 'stageTransitionDetail', stageTransitionDetail)
            const localVarPath = `/admin/stages/stages/transitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stageTransitionDetail, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StagesAdminApi - functional programming interface
 * @export
 */
export const StagesAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StagesAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new stage
         * @summary Creates a new stage
         * @param {StageCreationRequest} stageCreationRequest Stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStage(stageCreationRequest: StageCreationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStage(stageCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new transition
         * @summary Creates a new transition
         * @param {StageTransitionCreationRequest} stageTransitionCreationRequest Transition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransition(stageTransitionCreationRequest: StageTransitionCreationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageTransitionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransition(stageTransitionCreationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes an existing stage.
         * @summary Deletes an existing stage
         * @param {number} id stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStage(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deletes an existing transition.
         * @summary Deletes an existing transition
         * @param {number} id transition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTransition(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTransition(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * retrieves all initial stage transitions for a given entity type. Returns array of StageTransitionDetail objects.
         * @summary retrieves all initial stage transitions for an entity type.
         * @param {number} entityType Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInitialStageTransitions(entityType: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StageTransitionDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInitialStageTransitions(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary retrieves a single stage given an ID
         * @param {number} id Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStage(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * retrieves all the stages. Can supply a entityType query param to get stages for a specific entity Type.
         * @summary retrieves all the stages.
         * @param {number} [entityType] Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStages(entityType?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StageDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStages(entityType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary retrieves a single transition given an ID
         * @param {number} id Transition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransition(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageTransitionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransition(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * retrieves all the transitions. Can supply a entityType query param to get transitions for a specific entity Type, or stage query param to get transitions for a specific stage.
         * @summary retrieves all the transitions.
         * @param {number} [entityType] Entity Type ID
         * @param {number} [stage] Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransitions(entityType?: number, stage?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StageTransitionDetail>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransitions(entityType, stage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary sets the order for stages
         * @param {{ [key: string]: number; }} requestBody a Map of Stage ID keys and their corresponding sort index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderStages(requestBody: { [key: string]: number; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderStages(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary sets the order for transitions
         * @param {{ [key: string]: number; }} requestBody a Map of transition ID keys and their corresponding sort index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderTransitions(requestBody: { [key: string]: number; }, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderTransitions(requestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates an existing stage. id must match in the object and uri.
         * @summary Updates an existing stage
         * @param {number} id Stage ID
         * @param {StageDetail} stageDetail Stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStage(id: number, stageDetail: StageDetail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStage(id, stageDetail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates an existing transition. id must match in the object and uri.
         * @summary Updates an existing transition
         * @param {number} id Transition ID
         * @param {StageTransitionDetail} stageTransitionDetail Transition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransition(id: number, stageTransitionDetail: StageTransitionDetail, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StageTransitionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransition(id, stageTransitionDetail, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StagesAdminApi - factory interface
 * @export
 */
export const StagesAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StagesAdminApiFp(configuration)
    return {
        /**
         * Creates a new stage
         * @summary Creates a new stage
         * @param {StageCreationRequest} stageCreationRequest Stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStage(stageCreationRequest: StageCreationRequest, options?: any): AxiosPromise<StageDetail> {
            return localVarFp.createStage(stageCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new transition
         * @summary Creates a new transition
         * @param {StageTransitionCreationRequest} stageTransitionCreationRequest Transition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransition(stageTransitionCreationRequest: StageTransitionCreationRequest, options?: any): AxiosPromise<StageTransitionDetail> {
            return localVarFp.createTransition(stageTransitionCreationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an existing stage.
         * @summary Deletes an existing stage
         * @param {number} id stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStage(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteStage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an existing transition.
         * @summary Deletes an existing transition
         * @param {number} id transition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransition(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTransition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves all initial stage transitions for a given entity type. Returns array of StageTransitionDetail objects.
         * @summary retrieves all initial stage transitions for an entity type.
         * @param {number} entityType Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialStageTransitions(entityType: number, options?: any): AxiosPromise<Array<StageTransitionDetail>> {
            return localVarFp.getInitialStageTransitions(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary retrieves a single stage given an ID
         * @param {number} id Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStage(id: number, options?: any): AxiosPromise<StageDetail> {
            return localVarFp.getStage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves all the stages. Can supply a entityType query param to get stages for a specific entity Type.
         * @summary retrieves all the stages.
         * @param {number} [entityType] Entity Type ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStages(entityType?: number, options?: any): AxiosPromise<Array<StageDetail>> {
            return localVarFp.getStages(entityType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary retrieves a single transition given an ID
         * @param {number} id Transition ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransition(id: number, options?: any): AxiosPromise<StageTransitionDetail> {
            return localVarFp.getTransition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * retrieves all the transitions. Can supply a entityType query param to get transitions for a specific entity Type, or stage query param to get transitions for a specific stage.
         * @summary retrieves all the transitions.
         * @param {number} [entityType] Entity Type ID
         * @param {number} [stage] Stage ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransitions(entityType?: number, stage?: number, options?: any): AxiosPromise<Array<StageTransitionDetail>> {
            return localVarFp.getTransitions(entityType, stage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sets the order for stages
         * @param {{ [key: string]: number; }} requestBody a Map of Stage ID keys and their corresponding sort index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderStages(requestBody: { [key: string]: number; }, options?: any): AxiosPromise<void> {
            return localVarFp.orderStages(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary sets the order for transitions
         * @param {{ [key: string]: number; }} requestBody a Map of transition ID keys and their corresponding sort index.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderTransitions(requestBody: { [key: string]: number; }, options?: any): AxiosPromise<void> {
            return localVarFp.orderTransitions(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing stage. id must match in the object and uri.
         * @summary Updates an existing stage
         * @param {number} id Stage ID
         * @param {StageDetail} stageDetail Stage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStage(id: number, stageDetail: StageDetail, options?: any): AxiosPromise<StageDetail> {
            return localVarFp.updateStage(id, stageDetail, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing transition. id must match in the object and uri.
         * @summary Updates an existing transition
         * @param {number} id Transition ID
         * @param {StageTransitionDetail} stageTransitionDetail Transition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransition(id: number, stageTransitionDetail: StageTransitionDetail, options?: any): AxiosPromise<StageTransitionDetail> {
            return localVarFp.updateTransition(id, stageTransitionDetail, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StagesAdminApi - object-oriented interface
 * @export
 * @class StagesAdminApi
 * @extends {BaseAPI}
 */
export class StagesAdminApi extends BaseAPI {
    /**
     * Creates a new stage
     * @summary Creates a new stage
     * @param {StageCreationRequest} stageCreationRequest Stage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public createStage(stageCreationRequest: StageCreationRequest, options?: any) {
        return StagesAdminApiFp(this.configuration).createStage(stageCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new transition
     * @summary Creates a new transition
     * @param {StageTransitionCreationRequest} stageTransitionCreationRequest Transition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public createTransition(stageTransitionCreationRequest: StageTransitionCreationRequest, options?: any) {
        return StagesAdminApiFp(this.configuration).createTransition(stageTransitionCreationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an existing stage.
     * @summary Deletes an existing stage
     * @param {number} id stage ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public deleteStage(id: number, options?: any) {
        return StagesAdminApiFp(this.configuration).deleteStage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an existing transition.
     * @summary Deletes an existing transition
     * @param {number} id transition ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public deleteTransition(id: number, options?: any) {
        return StagesAdminApiFp(this.configuration).deleteTransition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * retrieves all initial stage transitions for a given entity type. Returns array of StageTransitionDetail objects.
     * @summary retrieves all initial stage transitions for an entity type.
     * @param {number} entityType Entity Type ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public getInitialStageTransitions(entityType: number, options?: any) {
        return StagesAdminApiFp(this.configuration).getInitialStageTransitions(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary retrieves a single stage given an ID
     * @param {number} id Stage ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public getStage(id: number, options?: any) {
        return StagesAdminApiFp(this.configuration).getStage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * retrieves all the stages. Can supply a entityType query param to get stages for a specific entity Type.
     * @summary retrieves all the stages.
     * @param {number} [entityType] Entity Type ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public getStages(entityType?: number, options?: any) {
        return StagesAdminApiFp(this.configuration).getStages(entityType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary retrieves a single transition given an ID
     * @param {number} id Transition ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public getTransition(id: number, options?: any) {
        return StagesAdminApiFp(this.configuration).getTransition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * retrieves all the transitions. Can supply a entityType query param to get transitions for a specific entity Type, or stage query param to get transitions for a specific stage.
     * @summary retrieves all the transitions.
     * @param {number} [entityType] Entity Type ID
     * @param {number} [stage] Stage ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public getTransitions(entityType?: number, stage?: number, options?: any) {
        return StagesAdminApiFp(this.configuration).getTransitions(entityType, stage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sets the order for stages
     * @param {{ [key: string]: number; }} requestBody a Map of Stage ID keys and their corresponding sort index.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public orderStages(requestBody: { [key: string]: number; }, options?: any) {
        return StagesAdminApiFp(this.configuration).orderStages(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary sets the order for transitions
     * @param {{ [key: string]: number; }} requestBody a Map of transition ID keys and their corresponding sort index.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public orderTransitions(requestBody: { [key: string]: number; }, options?: any) {
        return StagesAdminApiFp(this.configuration).orderTransitions(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing stage. id must match in the object and uri.
     * @summary Updates an existing stage
     * @param {number} id Stage ID
     * @param {StageDetail} stageDetail Stage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public updateStage(id: number, stageDetail: StageDetail, options?: any) {
        return StagesAdminApiFp(this.configuration).updateStage(id, stageDetail, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing transition. id must match in the object and uri.
     * @summary Updates an existing transition
     * @param {number} id Transition ID
     * @param {StageTransitionDetail} stageTransitionDetail Transition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StagesAdminApi
     */
    public updateTransition(id: number, stageTransitionDetail: StageTransitionDetail, options?: any) {
        return StagesAdminApiFp(this.configuration).updateTransition(id, stageTransitionDetail, options).then((request) => request(this.axios, this.basePath));
    }
}
